var _excluded = ["children", "pt"],
    _excluded2 = ["withBackground"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState, useEffect, cloneElement, Children } from 'react';
import PropTypes from 'prop-types';
import styled, { css, keyframes } from 'styled-components';
import Flex from '../Flex/Flex';
import Box from '../Box/Box';
import Loader from '../Loader/Loader';
export var PurpleBackgroundBox = styled(Box).withConfig({
  displayName: "PageLayout__PurpleBackgroundBox",
  componentId: "sc-91c2np-0"
})(["position:relative;", ""], function (_ref) {
  var flapHeight = _ref.flapHeight,
      theme = _ref.theme;
  return css(["background:", ";&:after{content:'';position:absolute;background:", ";top:100%;left:0;right:0;height:", ";}"], theme.colors.bgPrimary, theme.colors.bgPrimary, flapHeight || theme.space.xxl);
});
export var PurpleBackground = function PurpleBackground(props) {
  return /*#__PURE__*/React.createElement(PurpleBackgroundBox, props);
};
export var PageWrap = function PageWrap(_ref2) {
  var children = _ref2.children,
      pt = _ref2.pt,
      rest = _objectWithoutProperties(_ref2, _excluded);

  var _Children$toArray = Children.toArray(children),
      _Children$toArray2 = _toArray(_Children$toArray),
      firstChild = _Children$toArray2[0],
      restChildren = _Children$toArray2.slice(1);

  var firstChildIsPurpleBackground = firstChild.type === PurpleBackground;
  var styledFirstChild = firstChildIsPurpleBackground ? /*#__PURE__*/cloneElement(firstChild, {
    pt: pt
  }) : firstChild;

  var restProps = _objectSpread({}, rest);

  if (firstChildIsPurpleBackground) restProps.pt = 'none';
  return /*#__PURE__*/React.createElement(Box, _extends({
    pt: pt
  }, restProps), [styledFirstChild].concat(_toConsumableArray(restChildren)));
};
PageWrap.defaultProps = {
  pt: '7rem'
};
export var ContentWrap = styled(Box).withConfig({
  displayName: "PageLayout__ContentWrap",
  componentId: "sc-91c2np-1"
})(["position:relative;width:100%;max-width:", ";"], function (props) {
  var desktopBaseFontSize = 18;
  var padding = parseInt(props.theme.space.s, 10) * desktopBaseFontSize * 2;
  var contentWidth = props.contentWidth || "".concat(710 + padding, "px");
  var contentWidthWide = props.contentWidthWide || "".concat(1030 + padding, "px");
  return props.wide ? contentWidthWide : contentWidth;
});
ContentWrap.defaultProps = {
  px: 's',
  ml: 'auto',
  mr: 'auto'
};
export function PageWrapLoader(_ref3) {
  var withBackground = _ref3.withBackground,
      rest = _objectWithoutProperties(_ref3, _excluded2);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showLoader = _useState2[0],
      setShowLoader = _useState2[1];

  var loaderColor = showLoader ? 'textActionPrimary' : 'transparent';
  useEffect(function () {
    var timeout = setTimeout(function () {
      setShowLoader(true);
    }, 500);
    return function () {
      return clearTimeout(timeout);
    };
  }, []);
  var contents = /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "center",
    alignItems: "center",
    height: "40vh"
  }, /*#__PURE__*/React.createElement(Loader, {
    center: true,
    color: loaderColor
  }));
  return /*#__PURE__*/React.createElement(PageWrap, rest, withBackground ? /*#__PURE__*/React.createElement(PurpleBackground, {
    flapHeight: "0"
  }, contents) : contents);
}
PageWrapLoader.propTypes = {
  withBackground: PropTypes.bool
};
var fadeInUp = keyframes(["0%{transform:translateY(.5rem);opacity:0;}100%{transform:translateY(0);opacity:1;}"]);
var fadeInDown = keyframes(["0%{transform:translateY(-.5rem);opacity:0;}100%{transform:translateY(0);opacity:1;}"]);
export var FadeInContainer = styled.div.withConfig({
  displayName: "PageLayout__FadeInContainer",
  componentId: "sc-91c2np-2"
})(["animation:250ms ", " ease-out forwards;min-height:10vh;"], function (_ref4) {
  var down = _ref4.down;
  return down ? fadeInDown : fadeInUp;
});